import { Loader2, PhoneOutgoing } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface EnableOutboundCallingPromptProps {
  isEnabling: boolean
  onEnable: () => void
}

export function EnableOutboundCallingPrompt({ isEnabling, onEnable }: EnableOutboundCallingPromptProps) {
  return (
    <div className="text-left sm:max-w-xs sm:rounded-lg sm:border sm:border-purple-100 sm:bg-purple-50 sm:p-3">
      <div className="hidden items-start gap-2 sm:flex">
        <PhoneOutgoing className="mt-0.5 h-4 w-4 shrink-0 text-purple-600" />
        <div>
          <p className="text-sm font-medium text-purple-900">Outbound calling is not enabled</p>
          <p className="text-xs text-purple-700">
            Enable this so it can be selected when making outbound calls from Voice Agents and Campaigns.
          </p>
        </div>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-auto min-h-10 w-full whitespace-normal border-purple-200 py-2 text-purple-700 hover:bg-purple-100 hover:text-purple-800 sm:mt-2 sm:min-h-9"
        onClick={onEnable}
        disabled={isEnabling}
      >
        {isEnabling ? (
          <Loader2 className="mr-2 h-4 w-4 shrink-0 animate-spin" />
        ) : (
          <PhoneOutgoing className="mr-2 h-4 w-4 shrink-0" />
        )}
        <span>{isEnabling ? 'Enabling...' : 'Enable outbound calling'}</span>
      </Button>
    </div>
  )
}
